import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response, environment as env } from '@dabnet-kamu/libs/ui';
import { ControlConditionModel } from '../../../models/gen-control.model';

@Injectable()
export class CtlGenDropBoxMultiKontrolService {
  public period: number;
  public conditionColName: any;
  public conditionColText: any;
  public controlCondition: ControlConditionModel[];
  public customQuery = "";
  public queryParams: { [key: string]: any } = {};
  
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {}

  getData(filterColumn: string, code: any, control: any, type: string, codeField?: string, key?: string) {
    const columnArray: string[] = control.searchColumns?.split(',') || [];
    if (control.kodField && !columnArray.includes(control.kodField)) columnArray.push(control.kodField);
    if (control.descriptionField) {
      control.descriptionField.split(',').forEach((field: string) => {
        const trimmedField = field.trim();
        if (trimmedField && !columnArray.includes(trimmedField)) columnArray.push(trimmedField);
      });
    }

    let entityName = control.dlistMetadata.baseEntity + this.customQuery;
    const filterArr: any[] = [];
    
    const pushFilter = (f: any) => {
      if (filterArr.length > 0) filterArr.push('and');
      filterArr.push(f);
    };

    if (this.controlCondition) {
      this.controlCondition.forEach((item: any) => {
        pushFilter([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
      });
    }

    // Append dynamic query parameters
    if (this.queryParams) {
      Object.keys(this.queryParams).forEach(key => {
        const val = this.queryParams[key];
        if (val !== undefined && val !== null) {
          entityName += (entityName.includes('?') ? '&' : '?') + `${key}=${val}`;
        }
      });
    }

    const dataSource = this.dataCoreService.getOData(entityName, null, null, key);
    if (columnArray.length > 0) {
      dataSource.select(columnArray);
    }

    if (code) {
      if (type === 'number') pushFilter([control.kodField, '=', Number(code)]);
      else if (type === 'string') {
        if (filterColumn.length > 0) pushFilter([control.kodField, 'startswith', code]);
        else pushFilter([codeField || control.kodField, '=', code]);
      }
    }

    if (this.period) pushFilter(['Donem', '=', this.period]);
    if (this.conditionColName && this.conditionColText) pushFilter([this.conditionColName, '=', this.conditionColText]);

    if (filterArr.length > 0) {
      dataSource.filter(filterArr.length === 1 ? filterArr[0] : filterArr);
    }

    return dataSource;
  }

  getDlist(formName: string): any {
    const request = new GetDlist_Request({
      dListCode: formName
    });
    this._httpClient.post<GetDlist_Response>(`${env.lookupService}/System/GetDList`, request).pipe(
      tap(response => {
        this._gridControlsList.next(response.dListMetadata)
      }),
      catchError(err => throwError(err)),
      finalize(() => {})
    ).subscribe();
  }
}
